export const environment = {
	production: false,
	baseAPIURL: 'https://dev.api.subprod.newlios.toyota.com/aet/api/v1',
	TENANT_ID: 'https://login.microsoftonline.com/tmnatest.onmicrosoft.com',
	CLIENT_ID: '9d822665-267a-4ec4-83e5-f1002b928b0e',
	REDIRECT_URL: "https://aet.dev.lios.toyota.com/",
	LIOS_HOME_URL: 'https://dev.lios.toyota.com/',
	LOGOUT_REDIRECT_URL: 'https://dev.lios.toyota.com/',
	APM_DS_URI: 'https://api.sit.lios.toyota.com/apm/graphql',
	agGridLicenseKey: 'Using_this_{AG_Grid}_Enterprise_key_{AG-095410}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Toyota}_is_granted_a_{Multiple_Applications}_Developer_License_for_{5}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{7}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{18_January_2027}____[v3]_[01]_MTgwMDIzMDQwMDAwMA==46ac1b6b703b45287199e386ca8d5f25',
	SCOPES: ['https://tmnatest.onmicrosoft.com/e45b42dc-670d-4640-b95b-a24d12e73448/user_impersonation'],
	FILE_UPLOAD_URI: "https://dev.upload.subprod.newlios.toyota.com",
	TEMPLATE_EXCEL_URI: "https://dev.template.subprod.newlios.toyota.com",
	WEBSOCKET_URI: "wss://2u2u4khebk.execute-api.us-east-1.amazonaws.com/dev/",
	SENDMAIL_URL: "https://dev.api.subprod.newlios.toyota.com/windowTimes/sendmail",
	TASK_MANAGER: 'https://taskmanager.dev.lios.toyota.com',
	AET: 'https://ts.stage.portal.toyotasupplier.com/aet',
	ALARMS: 'https://alarms.dev.lios.toyota.com',
	FORECAST_ADMIN_DASHBOARD: 'https://ts.stage.portal.toyotasupplier.com/lios/forecast',
	CO2: 'https://liosapps.qa.toyota.com/co2/lp-upload',
	COST_PLANNING: 'https://costplanning.dev.lios.toyota.com',
	EBOI: 'https://eboi.dev.lios.toyota.com',
	TLD: 'https://tld.dev.lios.toyota.com',
	DD: 'https://ts.stage.portal.toyotasupplier.com/lios/delayindex#/delayeddispatch',
	REPORTS: 'https://app.powerbi.com/Redirect?action=OpenApp&appId=11db23f6-28df-4b47-bf4d-03bb6cab9246&ctid=8c642d1d-d709-47b0-ab10-080af10798fb&experience=power-bi',
	EXPORT: 'https://export.dev.lios.toyota.com',
	GROUPI: 'https://groupi.dev.lios.toyota.com',
	SCHEDULE_JOB: 'https://jpe.dev.lios.toyota.com',
	RETURNS_RELOAD: 'https://dev.lios.toyota.com/mshell/maintenance/returns-reload',
	SCHEDULE_DASHBOARD: 'https://jpe.dev.lios.toyota.com',
	TLMS_SEND: 'https://ts.stage.portal.toyotasupplier.com/lios/tlmssend',
	ALLO: 'https://allo.dev.lios.toyota.com',
};


